export default __webpack_public_path__ + "roboto-v27-latin-regular.4673b4537a84c7f7a130799aa6af329b.woff2";